import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { noop } from 'Helpers/PropTypes';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { FDPrimaryActionButton } from '@facet-wealth/design';

const JoinThreadButton = ({
  threadResource,
  onJoin,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { refreshAll } = useMessagesContext();

  const joinThread = async () => {
    try {
      const [joinThreadResource] = await threadResource?.relationship(fr.relationships.joinThread.name).link('related').get();
      await joinThreadResource.submit();
      await refreshAll();
      onJoin();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <FDPrimaryActionButton
      label={'Join thread'}
      size={'sm'}
      onClick={joinThread}
      test="messages-join-thread-button"
    />
  );
};

JoinThreadButton.defaultProps = {
  onJoin: noop,
};

JoinThreadButton.propTypes = {
  onJoin: PropTypes.func,
  threadResource: PropTypes.object.isRequired,
};

export { JoinThreadButton };
